import { mapLinkableEntityType } from '@api';
import type { FestivalEventType as ApiFestivalEventType } from 'src/api/generated/touring/types';
import type { FestivalEventType } from '../../types';

export const mapFestivalEventType = (
  api: ApiFestivalEventType
): FestivalEventType => ({
  startDate: api.startDate,
  endDate: api.endDate,
  festival: mapLinkableEntityType(api.festival),
  venue: mapLinkableEntityType(api.venue),
});
